<template>
	<div class="search-dict">
		<div class="el-search vue-top-padding radius">
			<div class="el-left">
				<el-button
					type="primary"
					size="small"
					icon="el-icon-plus"
					@click="addDict"
					>{{ $t("common.add") }}</el-button
				>
				<el-button
					type="danger"
					size="small"
					icon="el-icon-delete"
					:disabled="multipleSelection.length <= 0"
					@click="delBatchDict"
					>{{ $t("common.delete") }}</el-button
				>
			</div>
			<div class="el-right">
				<el-form
					ref="dict"
					:model="dict"
					:inline="true"
					label-width="10px"
					size="small"
					class="demo-form-inline el-input-height"
				>
					<el-form-item prop="name">
						<el-input
							v-model="dict.name"
							:placeholder="$t('searchDictType.dictName')"
							@input="onSubmit"
						></el-input>
					</el-form-item>
					<el-form-item prop="type">
						<el-input
							v-model="dict.type"
							:placeholder="$t('searchDictType.dictType')"
							@input="onSubmit"
						></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit" icon="el-icon-search">{{
							$t("common.search")
						}}</el-button>
						<el-button @click="resetSearch('dict')" icon="el-icon-refresh">{{
							$t("common.reset")
						}}</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SearchDictType",
	props: {
		dict: Object,
		multipleSelection: Array,
	},
	methods: {
		addDict() {
			this.$emit("addDict");
		},

		enableSelect(event) {
			this.$emit("enableSelect", event);
		},

		onSubmit() {
			this.$emit("onSubmit", this.dict);
		},

		resetSearch(formName) {
			this.$refs[formName].resetFields(); // 这个只是清除了表单数据，对象并没有重新赋值，所以调用下面的方法赋空值
			this.$toolUtil.clearForm(this.dict);
			this.$emit("resetSearch", this.dict);
		},

		delBatchDict() {
			this.$emit("delBatchDict");
		},
	},
};
</script>

<style scoped></style>
